<template>
  <div v-if="currentFormation">
    <div class="row">
      <div class="col-md-12 col-lg-6">
        <BreadCrumd
          :title="'Formations'"
          :description="'Nouvelle session de formation'"
        />
      </div>
      <div class="col-md-12 col-lg-6 mt-4">
        <div class="row" v-if="currentFormation">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-12">
                    Intitulé de la formation :
                    {{ currentFormation.intitule }}
                  </td>
                </tr>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence :
                    {{ currentFormation.document.reference }}
                  </td>
                  <td class="col-6">
                    Durée :
                    {{ currentFormation.duree + ' H' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row">
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="intitule"
                        >Intitulé <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('intitule') }"
                        id="intitule"
                        v-model="form.intitule"
                        type="text"
                        placeholder="Intitulé"
                        maxlength="100"
                      />
                      <has-error :form="form" field="intitule"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="lieu"
                        >Lieu <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('lieu') }"
                        id="lieu"
                        v-model="form.lieu"
                        type="text"
                        placeholder="Lieu"
                        maxlength="50"
                      />
                      <has-error :form="form" field="lieu"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_debut"
                        >Date début <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_debut"
                        name="date_debut"
                        placeholder="Date début"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_debut'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_debut"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date_fin"
                        >Date fin <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date_fin"
                        name="date_fin"
                        placeholder="Date fin"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date_fin'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date_fin"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="duree"
                        >Durée (heures)
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.duree = form.duree - 1 > 0 ? form.duree - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i class="fas fa-minus text-danger"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('duree'),
                          }"
                          id="duree"
                          v-model.number="form.duree"
                          placeholder="Durée (heures)"
                          required
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.duree++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i class="fas fa-plus text-success"></i>
                          </span>
                        </div>
                        <has-error :form="form" field="duree"></has-error>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="nbre_place"
                        >Nombre de places disponibles
                        <span class="text-danger">*</span></label
                      >
                      <div class="input-group">
                        <div
                          class="input-group-prepend bg-transparent"
                          @click="
                            form.nbre_place =
                              form.nbre_place - 1 > 0 ? form.nbre_place - 1 : 1
                          "
                        >
                          <span
                            class="input-group-text bg-transprent border-right-0"
                            role="button"
                          >
                            <i class="fas fa-minus text-danger"></i>
                          </span>
                        </div>
                        <input
                          type="text"
                          class="form-control text-center"
                          :class="{
                            'is-invalid': form.errors.has('nbre_place'),
                          }"
                          id="nbre_place"
                          v-model.number="form.nbre_place"
                          placeholder="Nombre de places disponibles"
                        />
                        <div
                          class="input-group-append bg-transparent"
                          @click="form.nbre_place++"
                        >
                          <span
                            class="input-group-text bg-transprent border-left-0"
                            role="button"
                          >
                            <i class="fas fa-plus text-success"></i>
                          </span>
                        </div>
                        <has-error :form="form" field="nbre_place"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="description">Description </label>
                      <textarea
                        v-model="form.description"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('description'),
                        }"
                        rows="10"
                      ></textarea>
                      <has-error :form="form" field="description"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="$router.push(sprov).catch(() => {})"
            >
              Liste des sessions de formation
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL_S from '@/http/rh/formation/session';
import URL_F from '@/http/rh/formation/formation';
import Form from 'vform';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      sprov: this.$route.params.sprov,
      form: new Form({
        formation: '',
        intitule: '',
        lieu: '',
        date_debut: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        date_fin: this.$options.filters.formatDate(
          moment(new Date(), 'DD/MM/YYYY').add(1, 'month'),
          'DD/MM/YYYY'
        ),
        duree: 1,
        nbre_place: 1,
        description: '',
      }),
      id: null,
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters('formation', ['currentFormation']),
  },
  watch: {
    currentFormation: {
      immediate: true,
      handler(formation) {
        if (formation) {
          this.form.duree = formation.duree;
          this.form.nbre_place = formation.nbre_place;
          this.form.intitule = formation.intitule;
        }
      },
    },
  },
  methods: {
    ...mapActions('formation', ['setCurrentFormation']),

    init() {
      this.setCurrentFormation(null);
      this.id = this.$route.params.id;
      if (this.$route.params.filter === 'cloner') {
        window.axios
          .all([
            window.axios.get(
              URL_F.FORMATION + '/' + this.$route.params.formationId
            ),
            window.axios.get(URL_S.SESSION + '/' + this.id, {
              params: {
                edit: true,
              },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.setCurrentFormation(resp1.data.formation);
              Object.assign(this.form, resp2.data.session);
              delete this.form.formation;
            })
          )
          .catch(() => {});
      } else {
        window.axios
          .get(URL_F.FORMATION + '/' + this.$route.params.formationId)
          .then((resp) => {
            this.setCurrentFormation(resp.data.formation);
          })
          .catch(() => {});
      }
    },
    submit() {
      if (this.currentFormation) {
        this.form.formation = this.currentFormation.uuid;
      }

      this.form
        .post(URL_S.SESSION)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.id) {
            this.id = null;
          }
          this.$router.push({
            name: 'rh_formation_session-show',
            params: { sessionId: resp.data.session.id, sprov: this.sprov },
          });
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
